<template>
  <div class="upload-multi-page-material">
    <div class="title">
      <div class="title-left">
        {{multiPage.elec_name}}
        <fliggy-select-file-btn
          v-if="isShowFliggyBtn"
          class="m-l-20"
          :order="order"
          :applicant="applicant"
          :material-name="multiPage.elec_name"
          :support-pdf="true"
          @confirm="onUploadByFliggy"
        ></fliggy-select-file-btn>
      </div>
      <div class="title-right">
        <!-- 在职证明在线生成，如果已经上传了，则隐藏提示 -->
        <on-job-online-btn
          :order="order"
          :applicant="applicant"
          :material="multiPage"
        ></on-job-online-btn>
      </div>
    </div>

    <div class="upload-content">

      <ul class="upload-list">
        <li v-for="(upload, index) in multiPage.upload" :key="index" class="upload-item" v-if="showEmptyUploadAtReuploadTime(upload, index)">

          <!-- 禁用是根据单个upload来判断的 -->
          <upload-item
            :pdf="true"
            :img-url="upload.url"
            :upload="upload"
            :forbid="forbidUpload(multiPage, upload, index)"
            :is-multi="true"
            :verify-passed="upload.elec_status === consts.ELEC_STATUS.qualified_0"
            :verify-not-pass="upload.elec_status === consts.ELEC_STATUS.unqualified_3"
            :is-reupload="isReupload"
            :file-name="`${multiPage.elec_name}${index + 1}.pdf`"
            :is-before-pay="isBeforePay"
            @uploadFile="(file, pos) => uploadMultiPage(file, pos, index)"
            @deleteFile="() => deleteMultiPageItem(index)"
            @reviewImage="reviewImage"></upload-item>
        </li>
      </ul>

      <!-- 多页资料的是放在下面的注意事项 -->
      <attention class="attention-box" :attention="multiPage.attention"></attention>

      <!-- 资料不完善备注 常规资料不完善展示在上面 (后面主要是做代码报错处理)-->
      <memo class="memo" v-if="multiMemoContent && (!multiPage.refuseUpload || (multiPage.refuseUpload && !multiPage.refuseUpload.checked))"
        :memo-content="multiMemoContent" :memo-title="showRequireMaterialText ? '建议补充资料' : '预审不合格'"></memo>

      <!-- 暂不补充 进来的时候会给资料一个 refuseUpload 对象 用于确定是否选中等 -->
      <div class="refuse-to-upload" v-if="multiPage.refuseUpload && showRefuseToUpload">
        <el-checkbox v-model="multiPage.refuseUpload.checked" @change="refuseToUploadChange($event, multiPage)">暂不补充</el-checkbox>
      </div>

      <!-- 资料不完善备注 暂不补充资料不完善展示在下面-->
      <memo class="memo" v-if="multiMemoContent && multiPage.refuseUpload && multiPage.refuseUpload.checked"
        :memo-content="multiMemoContent" :memo-title="showRequireMaterialText ? '建议补充资料' : '预审不合格'"></memo>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import uploadItem from './upload-item';
import attention from './attention';
import memo from './memo';
import utils from '../../libs/utils';
import Http from '../../libs/http';
import uploadFileService from '../../services/upload-file-service';
import materialConstants from '../../constants/material-constants';
import uploadService from '../../services/upload-service';
import applicantConstants from '../../constants/applicant-constants';
import FliggySelectFileBtn from './ota/fliggy-select-file-btn.vue';
import OnJobOnlineBtn from './component/on-job-online-btn.vue';

export default {
  name: 'uploadMultiPageMaterial',
  components: {
    attention,
    uploadItem,
    memo,
    FliggySelectFileBtn,
    OnJobOnlineBtn,
  },
  props: {
    multiPage: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    isOptional: {
      type: Boolean,
      required: true,
      default: false,
    },
    isReupload: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      consts: {
        ELEC_STATUS: materialConstants.ELEC_STATUS,
      },
    };
  },
  computed: {
    // 订单状态是否还没支付
    isBeforePay() {
      if (!this.order.order_status) return false;
      return uploadService.isOrderStatusBeforePay(this.order.order_status);
    },

    // 多页资料的memo要合并到一起
    multiMemoContent() {
      let memoList = this.multiPage.upload
        .filter(item => item.memo && (item.elec_status === 3 || item.elec_status === 1))
        .map(item => item.memo);

      // 去重+去除空
      memoList = Array.from(new Set(memoList));

      return memoList.join('\n');
    },

    // 是否显示暂不上传
    showRefuseToUpload() {
      // 申请人必需是资料不完善 且 资料一定是可选资料 才显示
      if (this.applicant.applicant_status !== applicantConstants.STATUS.verifyNotPassed_2 && this.isOptional) {
        return false;
      }

      // 没有图片不显示
      if (this.multiPage.upload.length === 0) {
        return false;
      }

      // 暂不上传一定只有一个upload项
      if (this.multiPage.upload.length === 1) {
        const upload = this.multiPage.upload[0];

        // 预审通过了不显示
        if (upload.elec_status === materialConstants.ELEC_STATUS.qualified_0) {
          return false;
        }

        // 已经是 用户选择了暂不上传 且 预审又不不合格，为了保证只能选择暂不上传一次
        if (upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6
              && upload.elec_status === materialConstants.ELEC_STATUS.unqualified_3) {
          return false;
        }

        // 选了暂不上传 且 已经上传了图片 且 待预审
        if (upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6
              && upload.elec_status === materialConstants.ELEC_STATUS.waittingForVerified_2
                && upload.url) {
          return false;
        }

        // 走到这里的时候只需要关注特殊状态就可以了
        return upload.special_code === materialConstants.SPECIAL_CODE.materialRequired_5
          || upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6;
      }
    },

    // 是否显示需补充资料的字符
    showRequireMaterialText() {
      // 可选才有需补充资料
      if (this.isOptional) {
        if (this.multiPage && this.multiPage.upload && this.multiPage.upload.length === 1
          && this.multiPage.upload[0].special_code === materialConstants.SPECIAL_CODE.materialRequired_5) {
          return true;
        }
      }

      return false;
    },
    // 是否显示飞猪选择资料按钮，其实就看最后一个是否是空的新增，就知道是否是
    isShowFliggyBtn() {
      try {
        const lastUpload = this.multiPage.upload[this.multiPage.upload.length - 1];
        return !this.forbidUpload(this.multiPage, lastUpload, this.multiPage.upload.length - 1) && !lastUpload.url && this.showEmptyUploadAtReuploadTime(lastUpload, this.multiPage.upload.length - 1);
      } catch (error) {
        return false;
      }
    },
  },
  methods: {

    // 禁用上传
    forbidUpload(multiPage, upload, index) {
      // 重新上传页面才有禁用
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const isApplicantVerifyNotPass = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，不能上传
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        // 用户没有上传过
        const isEmptyMaterial = this.multiPage.upload.length === 1 && this.multiPage.upload[0].temp;

        // 申请人资料不完善，且这个多页资料没有上传过任意资料
        if (isApplicantVerifyNotPass && isEmptyMaterial) {
          return true;
        }

        // 所有的图片都是合格的，就直接不显示了
        const isAllImgQualified = this.multiPage.upload.every((upload) => {
          // 如果是临时的, 就不管状态
          if (upload.temp) {
            return true;
          }
          // 如果是后台返回的，注意：可能是需补充资料的
          return upload.elec_status === materialConstants.ELEC_STATUS.qualified_0;
        });

        // 如果全部都合格了
        if (isAllImgQualified) {
          // 最后这个要禁用
          if (index + 1 === this.multiPage.upload.length) {
            return true;
          }

          // 其他的根据状态来看
          return upload.elec_status === materialConstants.ELEC_STATUS.qualified_0;
        }

        // 暂不上传
        const isMaterialSelectRefuseToUpload =
          upload &&
            upload.elec_status === materialConstants.ELEC_STATUS.waittingForVerified_2 &&
              upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6;

        // 预审通过
        const isUploadVerifyPassed = upload && upload.elec_status === materialConstants.ELEC_STATUS.qualified_0;

        // 预审通过也禁用
        return isUploadVerifyPassed || isMaterialSelectRefuseToUpload;
      }

      return false;
    },

    // 在重新上传的时候是否显示空的upload项
    showEmptyUploadAtReuploadTime(upload, index) {
      // 有内容就直接过
      if (upload.url) return true;

      // 重新上传资料页面
      if (this.isReupload) {
        // 申请人状态还不是资料不完善，现在是要显示上传项的，但是是禁用的
        if (this.applicant.applicant_status !== applicantConstants.STATUS.verifyNotPassed_2) {
          return true;
        }

        // 所有的图片都是合格的，就直接不显示了
        const isAllImgQualified = this.multiPage.upload.every((upload) => {
          // 如果是临时的, 就不管状态
          if (upload.temp) {
            return true;
          }
          // 如果是后台返回的，注意：可能是需补充资料的
          return upload.elec_status === materialConstants.ELEC_STATUS.qualified_0;
        });

        if (isAllImgQualified) {
          if (index + 1 === this.multiPage.upload.length) {
            return true;
          }
          return false;
        }

        // 如果多页资料在资料不完善的时候，有资料不完善的项，还有需补充资料的项，要先让用户上传完资料不完善的项，然后再显示待上传的项
        const haveUnqualifiedUpload = this.multiPage.upload.some(upload => upload.elec_status === materialConstants.ELEC_STATUS.unqualified_3);
        const haveTemporarilyNotUpload = this.multiPage.upload.some(upload => upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6);

        // 只有一个，且是暂不上传
        if (this.multiPage.upload.length === 1) {
          // 如果是临时的
          if (upload.temp) {
            return true;
          }
          return this.multiPage.upload[0].special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6
              || this.multiPage.upload[0].special_code === materialConstants.SPECIAL_CODE.materialRequired_5;
        }
        // 不只有一个上传项目

        // 如果有暂不上传的，则显示暂不上传的项
        if (haveTemporarilyNotUpload) {
          return upload.special_code > 0;
        }

        // 有资料不完善的，就不显示
        return !haveUnqualifiedUpload;
      }

      // 不是重新上传就都显示
      return true;
    },

    // 暂不上传切换
    refuseToUploadChange(event, material) {
      const checked = event.target.checked;

      // 抛出事件外面统一处理
      this.$emit('refuseUploadChange', checked, material);
    },

    /**
     * 为选中的文件初始化上传项
     * @param {Array} files 文件列表
     */
    initUploadItemForSelectedFileList(files) {
      // 如果为0，肯定不处理，如果为1，则在前面的处理里面已经给了一个坑
      if (files.length > 0) {
        const fisrtEmptyUploadItem = _.find(this.multiPage.upload, upload => !upload.url);
        let fisrtEmptyUploadItemPos = fisrtEmptyUploadItem.pos;

        // 有多少个文件就要多少个坑，因为之前的那个用了得新建一个新得坑
        for (let i = 0; i < files.length; i++) {
          fisrtEmptyUploadItemPos++;
          let uploadItem = {};

          // 最后一个资料需要是待上传
          if (i === files.length - 1) {
            uploadItem = uploadService.createEmptyElecUploadItem({
              pos: fisrtEmptyUploadItemPos,
              elec_status: materialConstants.ELEC_STATUS.waittingForUploadMaterial_1,
            });
          } else {
            // 其他的是待预审
            uploadItem = uploadService.createEmptyElecUploadItem({
              pos: fisrtEmptyUploadItemPos,
              elec_status: materialConstants.ELEC_STATUS.waittingForVerified_2,
            });
          }

          this.multiPage.upload.push(uploadItem);
        }
      }
    },

    /**
     * 设置文件url和loading
     * @param {Number} index 下标
     * @param {File} file 上传的文件
     */
    setFileAndUrlAndLoading(index, file) {
      window.URL = window.URL || window.webkitURL;
      this.multiPage.upload[index].file = file;
      // this.multiPage.upload[index].url = window.URL.createObjectURL(file);

      // 设置loading
      this.$set(this.multiPage.upload[index], 'loading', true);
    },

    /**
     * 设置每个空的上传坑的数据
     * @param {Array} files 文件列表
     */
    setEachEmptyUploadData(files) {
      // 根据没有url的那个找到第一个待上传的
      let fisrtEmptyUploadItemIndex = _.findIndex(this.multiPage.upload, upload => !upload.url);

      // 循环处理数据到upload上
      files.forEach((file) => {
        this.setFileAndUrlAndLoading(fisrtEmptyUploadItemIndex, file);

        // 移动初始位置
        fisrtEmptyUploadItemIndex += 1;
      });
    },

    /**
     * 上传所有资料
     * @param {Array} filesArr 文件列表
     * @param fileType 类型，key: 直接的文件key， file: 文件对象
     */
    uploadAllFiles(filesArr, fileType) {
      // 前面设置了loading，这里的第一个loading那就是待上传的第一个
      let fisrtEmptyUploadItemIndex = _.findIndex(this.multiPage.upload, upload => upload.loading);
      let countIndex = 0;
      const stack = [];

      const next = (file) => {
        const fn = stack[countIndex];
        countIndex += 1;
        fn(file);
      };

      // 使用函数队列处理异步循环
      /* eslint-disable no-unused-vars */
      filesArr.forEach((file) => {
        stack.push((file) => {

          // 执行上传
          const index = fisrtEmptyUploadItemIndex;
          const dowloadName = `${this.applicant.applicant_name}${this.multiPage.elec_name}${index + 1}.pdf`;
          Promise.resolve(fileType === 'key' ? file : uploadFileService.uploadFile(file, false, { noKey: true })).then((res) => {
            uploadFileService.doUpload(this.multiPage, this.multiPage.upload[index], this.applicant.user_order_id, this.applicant.order_applicant_id, res, dowloadName).then(() => {

              // 重新上传(此处很特殊：多页资料在后台添加需补充资料项，然后点击需补充资料的那一项，选择的时候选择了多张张片)
              if (this.isReupload && this.multiPage.upload[index].memo) {
                this.multiPage.upload[index].memo = '';
                this.multiPage.upload[index].elec_status = materialConstants.ELEC_STATUS.waittingForVerified_2;
                this.multiPage.upload[index].special_code = 0;
              }
            }).catch((e) => {
              if (e) console.log(e);
            });
          }).catch((e) => {
            if (e) console.log(e);
          });

          // 初始位置后移动
          fisrtEmptyUploadItemIndex++;

          // 调用后续
          if (filesArr.length > countIndex) {
            next(filesArr[countIndex]);
          }
        });
      });

      next(filesArr[0]);
    },

    // 上传多页资料
    uploadMultiPage(files, pos, index) {
      // 转为真正的数组
      const filesArr = Array.from(files);
      // 在这里可以根据url判断是不是文件替换
      const isReplaceFile = Boolean(this.multiPage.upload[index].url);
      if (!isReplaceFile && ((this.multiPage.upload.length + filesArr.length) > 51)) {
        // 最多50张，超过报错,51是因为有一个是空的
        utils.msg.error('最多可上传50项!');
        return;
      }

      // 选了多个文件的时候的要先添加出一堆坑，因为upload-item组件内部的控制，只会出现点击最后一个的时候出现多选文件的情况
      if (files.length > 1) {
        // 为选中的文件初始化上传项
        this.initUploadItemForSelectedFileList(filesArr);

        // 设置每个空的上传坑的数据
        this.setEachEmptyUploadData(filesArr);

        // 上传所有文件
        this.uploadAllFiles(filesArr);
      } else {
        // 只有一个就直接去除第一个文件
        const file = files[0];

        // 在这里可以根据url判断是不是文件替换
        const isReplaceFile = Boolean(this.multiPage.upload[index].url);

        // 设置
        this.setFileAndUrlAndLoading(index, file);

        const dowloadName = `${this.applicant.applicant_name}${this.multiPage.elec_name}${index + 1}.pdf`;

        // 上传
        uploadFileService.uploadFile(file, false, { noKey: true }).then((res) => {
          uploadFileService.doUpload(this.multiPage, this.multiPage.upload[index], this.applicant.user_order_id, this.applicant.order_applicant_id, res, dowloadName).then(() => {
            // 重新上传
            if (this.isReupload) {
              this.multiPage.upload[index].memo = '';
              this.multiPage.upload[index].elec_status = materialConstants.ELEC_STATUS.waittingForVerified_2;
              this.multiPage.upload[index].special_code = 0;
            }
          }).catch((e) => {
            if (e) console.log(e);
          });
        }).catch((e) => {
          if (e) console.log(e);
        });

        // 不是替换才加一个
        if (!isReplaceFile) {
          // 多页资料上传了要加一个
          this.multiPage.upload.push(
            uploadService.createEmptyElecUploadItem({
              pos: this.multiPage.upload[this.multiPage.upload.length - 1].pos + 1,
              elec_status: materialConstants.ELEC_STATUS.waittingForUploadMaterial_1,
              temp: true,
            }),
          );
        }
      }
    },
    // 飞猪资料上传
    onUploadByFliggy({ key_list }) {
      // 为选中的文件初始化上传项
      this.initUploadItemForSelectedFileList(key_list);
      // 设置每个空的上传坑的数据
      this.setEachEmptyUploadData(key_list);
      // 上传所有文件
      this.uploadAllFiles(key_list, 'key');
    },

    // 删除多页资料的一项
    deleteMultiPageItem(index) {
      utils.msgbox.confirm('确定要删除该文件吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        Http.post('/applicant_elec_delete', {
          user_order_id: this.applicant.user_order_id,
          order_applicant_id: this.applicant.order_applicant_id,
          delete_obj: [{
            elec_id: this.multiPage.elec_id,
            pos: this.multiPage.upload[index].pos,
          }],
        }).then(() => {
          this.multiPage.upload = this.multiPage.upload.filter(upload => upload.pos !== this.multiPage.upload[index].pos);
          utils.msg.success('删除成功!');
        }).catch(() => {
          utils.msg.error('删除失败!');
        });
      });
    },

    // 预览图片
    reviewImage(imageSrc) {
      this.$emit('reviewImage', imageSrc);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.upload-multi-page-material {
  line-height: 1;
  background-color: #fff;
  .title {
    padding: 30px 30px 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left{
      display: flex;
      align-items: center;
    }
    .title-right{
      display: flex;
      align-items: center;
    }
  }
  .upload-content {
    padding: 0 30px 30px 30px;
    .upload-list {
      display: flex;
      flex-wrap: wrap;
      .upload-item {
        width: 200px;
        height: 130px;
        margin-right: 35px;
        margin-bottom: 30px;
      }
    }
    .attention-box {
      margin-top: -10px;
    }
    .memo {
      margin-top: 20px;
    }
    .refuse-to-upload {
      margin-top: 20px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/upload/upload-multi-page-material.vue